import React from 'react';
import FormGroup from './FormGroup.jsx';
import Checkbox from './Checkbox.jsx';
import ProgressEvents from '../lib/ProgressEvents.js';
import AlertEvents from '../lib/AlertEvents.js';
import Alerts from './Alerts.jsx';
import ProgressBar from './ProgressBar.jsx';
import Layout from './Layout.jsx'

class LabMaintenanceForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
        };
        this.checkBoxes = [
            {name: 'labaddresssw', label: 'Display Addresses' },
            {name: 'labdatewantedsw', label: 'Display Wanted Date'},
            {name: 'labholdsw', label: 'Display Hold Switch'},
            {name: 'laballowuncut', label: 'Display Uncut Orders'},
            {name: 'labsplitnamesw', label: 'Split name on order entry'}
        ];

        this.progressBar = new ProgressEvents();
        this.alerts = new AlertEvents();
    }

    fetchLab() {
        let req = fetch('/webservice2/lab?token=' + this.props.token + '&id=' + this.props.lab_id);
        return req.then((resp) => resp.json()).then(this.updateView.bind(this))
    }

    updateView(json) {
        if(json.result === 'successful') {
            let record = json.readlabrecord;
            this.setState(record);
            this.setState({
                loaded: true,
                copyfiles: '0',
                recorddigest: json.recorddigest,
            });

        } else {
            this.setState({
                loaded: false
            });
        }
    }

    componentWillMount() {
        this.fetchLab();
    }

    handleInputChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleCheckboxChange(e) {
        this.setState({
            [e.target.name]: e.target.checked ? '1' : '0'
        })
    }

    updateLab(data) {
        let alert = this.alerts.add({ status: 'warning', message: "Saving..."});
        this.setState({ updating: true });
        fetch('/webservice2/lab', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        }).then((resp) => resp.json())
            .then((json) => {
                this.alerts.remove(alert);
                this.fetchLab();
                this.setState({ updating: false });
                if(json.result === 'successful') {
                    this.alerts.add({ status: 'success', message: 'Lab successfully saved'});
                } else {
                    this.alerts.add({
                        status: 'danger',
                        message: 'Error - ' + json.result
                    });
                }
            });
    }

    copyFile(fileName) {
        let endpoint = fileName.toLowerCase();

        return fetch('/webservice2/lab/copy' + endpoint, {
            method: 'POST',
            body: JSON.stringify({ labid: this.state.labid }),
            headers: new Headers({ 'Content-Type': 'application/json'})
        }).then(resp => resp.json()).then((json) => {
            this.progressBar.increment();
            if(json.result !== 'successful') {
                this.alerts.add({ status: 'danger', message: `${fileName} file could not be copied`})
            }
        })
    }

    copyFiles() {
        this.setState({ copying: true, copyfiles: '0' });
        let alert = this.alerts.add({status: 'warning', message: "Copying Files"});
        this.progressBar.start();
        let copies = [
            this.copyFile('RXLENSES'),
            this.copyFile('RXMATDSC'),
            this.copyFile('OMLENS'),
            this.copyFile('OMMAT'),
            this.copyFile('RXADDON')
        ];
        Promise.all(copies).then(() => {
            this.alerts.remove(alert);
            this.alerts.add({ status: 'success', message: 'Files finished copying' });
            this.progressBar.stop();
            this.setState({ copying: false });
        })
    }

    handleSubmit() {
        let data = this.state;
        data.token = this.props.token;
        this.alerts.clear();
        this.updateLab(data);
        if(data.copyfiles === '1') this.copyFiles(data);
    }

    render() {
        if(!this.state.loaded) return (
            <Layout>Loading...</Layout>
        );

        return (
            <React.Fragment>
                <Alerts eventHandler={this.alerts}/>
                <ProgressBar max={5} eventHandler={this.progressBar} />
                <Layout>
                    <FormGroup
                        name={'labname'}
                        label={'Lab ID'}
                        value={ this.state.labname }
                        onChange={ this.handleInputChange.bind(this) }
                    />
                    {
                        this.checkBoxes.map((cb) =>
                            <Checkbox
                                key={cb.name}
                                name={cb.name}
                                label={cb.label}
                                value={this.state[cb.name] === '1' }
                                onChange={this.handleCheckboxChange.bind(this)}
                                onChange={this.handleCheckboxChange.bind(this)}
                            />
                        )
                    }
                    <Checkbox
                        name={'copyfiles'}
                        label={'Copy Files To Server'}
                        value={this.state['copyfiles'] === '1'}
                        onChange={this.handleCheckboxChange.bind(this)}
                        disabled={this.state.copying}
                    />
                    <p className={'text-danger'} >
                        Please Note:
                        Rx-Site will be unavailable for 1-2 minutes while files are being copied.
                        Only use this feature during low usage times.
                    </p>
                    <div className={'form-group'} >
                        <button className={'btn btn-positive'} onClick={this.handleSubmit.bind(this)} disabled={this.state.updating}>Submit</button>
                    </div>
                </Layout>
            </React.Fragment>
        );
    }
}
export default LabMaintenanceForm;
